import React from 'react';

/**
 * Coquille commune aux trois écrans d'authentification.
 *
 * Ce qu'elle remplace : trois copies d'un balisage généré par v0.dev, truffé de
 * classes qui ne produisaient RIEN (`bg-background`, `text-muted-foreground`,
 * `border-input`, `ring-ring`, `text-primary-foreground` — aucune n'est définie
 * dans tailwind.config.js), avec un bouton `bg-indigo-700` au lieu du violet de
 * marque. Sur « Mot de passe oublié », le fichier écrivait même `class=` au lieu
 * de `className=` : React ignorait tout, la page s'affichait sans aucun style.
 */
export default function AuthCard({ title, subtitle, children, footer }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-base-200/40 p-4">
      <div className="w-full max-w-md rounded-2xl border border-base-200 bg-base-100 p-8 shadow-sm">
        <img src="/images/bsr-logo.png" alt="BackStageRate" className="mb-7 h-7 w-auto" />
        <h1 className="text-2xl font-bold leading-tight text-base-content">{title}</h1>
        {subtitle && <p className="mt-1.5 text-sm text-base-content/60">{subtitle}</p>}
        <div className="mt-7">{children}</div>
        {footer && <div className="mt-6 text-center text-sm text-base-content/70">{footer}</div>}

        {/* Les trois ecrans d'authentification passent par ici : c'est le point
            d'entree du produit, et donc l'endroit ou ces liens se trouvent. */}
        <nav className="mt-8 flex flex-wrap justify-center gap-4 border-t border-base-200 pt-4 text-xs text-base-content/50">
          <a href="/mentions-legales" className="hover:underline">Mentions légales</a>
          <a href="/confidentialite" className="hover:underline">Confidentialité</a>
        </nav>
      </div>
    </div>
  );
}

/** Champ de formulaire : libellé réellement associé + style unique. */
export function AuthField({ id, label, hint, ...inputProps }) {
  return (
    <div>
      <div className="mb-1.5 flex items-baseline gap-3">
        <label htmlFor={id} className="text-sm font-medium text-base-content">
          {label}
        </label>
        {hint && <span className="ml-auto text-sm">{hint}</span>}
      </div>
      <input id={id} className="input input-bordered w-full bg-base-100" {...inputProps} />
    </div>
  );
}
